import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";
import { toggleHeader } from "../../helper/functions";
import PageNotFound from "../PageNotFound";

interface Props {}

const HandleRedirection: React.FC<Props> = () => {
  const { shortId } = useParams();
  const [error, setError] = useState("");

  const getMainUrlAndRedirect = async (shortId: string) => {
    await api
      .FetchLinkById(shortId)
      .then((res) => {
        if (res.status === 200) {
          window.location.href = res.data.data;
        }
      })
      .catch((err) => {
        setError("Invalid short URL.");
      });
  };

  useEffect(() => {
    toggleHeader(false);
    if (!shortId) {
      setError("Invalid short URL.");
      return;
    }
    getMainUrlAndRedirect(shortId);
  }, [shortId]);

  if (!error) {
    return null;
  }

  return (
    <>
      <PageNotFound />
    </>
  );
};

export default HandleRedirection;
